import { render, staticRenderFns } from "./room-select.vue?vue&type=template&id=68445248"
import script from "./room-select.vue?vue&type=script&lang=js"
export * from "./room-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports